import { AdminUpdateAccountPayload, AdminUpdateAccountResult } from "tech-health-assessment-sdk/dist"
import { api } from "../../../../../services/core-api-service"

class AdminAccountCardService {
    updateAccount(accountId: string, payload: AdminUpdateAccountPayload): Promise<AdminUpdateAccountResult> {
        return api.admin.updateAccount(accountId, payload)
    }
}

export const service = new AdminAccountCardService()